export default {
    collection: [],
    term: ""
}